var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3334 2H6.33337C5.78025 2 5.33337 2.44687 5.33337 3V29C5.33337 29.5531 5.78025 30 6.33337 30H26.3334C26.8865 30 27.3334 29.5531 27.3334 29V3C27.3334 2.44687 26.8865 2 26.3334 2ZM18.2084 4.25H21.2084V10.8094L19.7552 9.75L18.2084 10.8562V4.25ZM7.58337 27.75V4.25H16.3334V13.5281C16.3334 13.6312 16.3646 13.7344 16.4271 13.8188C16.4651 13.8724 16.5133 13.918 16.5689 13.9528C16.6246 13.9877 16.6866 14.0112 16.7514 14.022C16.8162 14.0327 16.8825 14.0305 16.9465 14.0155C17.0104 14.0004 17.0708 13.9729 17.124 13.9344L19.7427 12.0625L22.2865 13.9187C22.3709 13.9812 22.474 14.0156 22.5802 14.0156C22.8552 14.0156 23.0802 13.7906 23.0802 13.5156V4.25H25.0802V27.75H7.58337Z",
    fill: "#005CE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.2084 10.8094V4.25H18.2084V10.8562L19.7552 9.75L21.2084 10.8094Z",
    fill: "#005CE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.0803 4.25V13.5156C23.0803 13.7906 22.8553 14.0156 22.5803 14.0156C22.474 14.0156 22.3709 13.9812 22.2865 13.9187L19.7428 12.0625L17.124 13.9344C17.0708 13.9729 17.0104 14.0004 16.9465 14.0155C16.8825 14.0305 16.8162 14.0327 16.7514 14.022C16.6866 14.0112 16.6246 13.9877 16.5689 13.9528C16.5133 13.918 16.4651 13.8724 16.4271 13.8188C16.3646 13.7344 16.3334 13.6312 16.3334 13.5281V4.25H7.58337V27.75H25.0803V4.25H23.0803Z",
    fill: "#005CE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c1f8c44bad44289dea34936a1f995e1b.svg";
export { ForwardRef as ReactComponent };